import {Link} from "react-router-dom";

export default function WebDev() {
  return (
    <div className="webdev">

      {/* HERO */}
      <section className="webdev-hero">
        <h2>Professional Web Development Services</h2>
        <p>
          We build modern, scalable and responsive web applications
          for businesses, startups and institutions using the latest
          technologies.
        </p>
      </section>


      {/* TECHNOLOGIES */}
      <section className="webdev-tech">

        <h3>Technologies We Use</h3>

        <div className="webdev-tech-grid">

          <div className="webdev-tech-card">HTML & CSS</div>
          <div className="webdev-tech-card">JavaScript</div>
          <div className="webdev-tech-card">React.js</div>
          <div className="webdev-tech-card">Node.js</div>
          <div className="webdev-tech-card">Express.js</div>
          <div className="webdev-tech-card">MongoDB</div>

        </div>

      </section>


      {/* SERVICES */}
      <section className="webdev-services">

        <h3>Our Web Development Services</h3>

        <div className="webdev-service-grid">

          <div className="webdev-service-card">
            <h4>Business Websites</h4>
            <p>Professional websites for companies and startups.</p>
          </div>

          <div className="webdev-service-card">
            <h4>ERP & Management Systems</h4>
            <p>Custom ERP software for schools and businesses.</p>
          </div>

          <div className="webdev-service-card">
            <h4>E-Commerce Solutions</h4>
            <p>Online stores with payment integration.</p>
          </div>

          <div className="webdev-service-card">
            <h4>Custom Web Applications</h4>
            <p>Tailored solutions built according to your needs.</p>
          </div>

        </div>

      </section>


      {/* PROCESS */}
      <section className="webdev-process">

        <h3>Our Development Process</h3>

        <div className="webdev-process-grid">

          <div className="process-card">
            <h4>Requirement Analysis</h4>
            <p>Understanding your business requirements.</p>
          </div>

          <div className="process-card">
            <h4>Design</h4>
            <p>Creating modern and user-friendly UI designs.</p>
          </div>

          <div className="process-card">
            <h4>Development</h4>
            <p>Building scalable and secure applications.</p>
          </div>

          <div className="process-card">
            <h4>Deployment</h4>
            <p>Hosting and launching your project online.</p>
          </div>

        </div>

      </section>


      {/* CTA */}
      <section className="webdev-cta">

        <h3>Let’s Build Your Project</h3>

        <p>
          Contact us today to discuss your project requirements and
          bring your ideas to life.
        </p>

        <Link className="app-cta-link" to="/contact">Request a Quote</Link>

      </section>

    </div>
  );
}
